var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 1A2.506 2.506 0 001 3.5v13C1 17.876 2.124 19 3.5 19h13c1.376 0 2.5-1.124 2.5-2.5v-13C19 2.124 17.876 1 16.5 1h-13zm0 1h13c.84 0 1.5.66 1.5 1.5v13c0 .84-.66 1.5-1.5 1.5h-13c-.84 0-1.5-.66-1.5-1.5v-13C2 2.66 2.66 2 3.5 2z",
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13a.5.5 0 00-.5.5v1c0 .822.678 1.5 1.5 1.5h9c.822 0 1.5-.678 1.5-1.5v-1a.5.5 0 10-1 0v1c0 .282-.218.5-.5.5h-9a.493.493 0 01-.5-.5v-1a.5.5 0 00-.5-.5z",
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4a.5.5 0 00-.5.5v7.12L6.842 9.134a.5.5 0 10-.684.73l3 2.803c.473.442 1.21.442 1.684 0l3-2.803a.5.5 0 10-.684-.73L10.5 11.619V4.5A.5.5 0 0010 4z",
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.5
  })));
}
export default SvgIconDownload;